import { Col, Row } from 'antd'
import Link from 'next/link'
import BASE_CONFIG from 'src/configs/base'
import { convertImagePath } from 'src/utils/common'
import PostNews from '../PostNews'

const PostNewsList = ({ leftNews, hotNews }) => {
	return (
		<div className="c-post__news__list">
			<Row>
				<Col lg={16} xl={16} md={24} sm={24} xs={24}>
					<div className="news-left">
						<ul className="left-post__news__list">
							{leftNews.slice(0, 3).map((e) => (
								<li key={e.Id} className="post__news__list-item">
									<PostNews data={e} />
								</li>
							))}
							{hotNews && (
								<li>
									<div className="news-right mb">
										<div className="right-hot__news">
											<div className="news-container">
												{/* eslint-disable-next-line @next/next/no-img-element */}
												<img src={convertImagePath(hotNews.Thumb)} alt={hotNews.Name} />
												<div className="hot__news-info">
													<Link
														href={`/tin-tuc/${hotNews.CategorySlug}/${
															hotNews.SEO.Slug || BASE_CONFIG.DEFAULT_SEO_SLUG
														}/${hotNews.Id}`}
													>
														<h2 className="info-title">{hotNews.Name}</h2>
													</Link>
													<p className="info-description">{hotNews.Summary}</p>
												</div>
											</div>
										</div>
									</div>
								</li>
							)}
							{leftNews.slice(3).map((e) => (
								<li key={e.Id} className="post__news__list-item">
									<PostNews data={e} />
								</li>
							))}
						</ul>
					</div>
				</Col>
				{hotNews && (
					<Col lg={8} xl={8} md={24} sm={24} xs={24}>
						<div className="news-right">
							<div className="right-hot__news">
								<div className="news-container">
									{/* eslint-disable-next-line @next/next/no-img-element */}
									<img
										src={
											hotNews?.ThumbOfPinPost
												? convertImagePath(hotNews.ThumbOfPinPost)
												: convertImagePath(hotNews.Thumb)
										}
										alt={hotNews.Name}
									/>
									<div className="hot__news-info">
										<Link
											href={`/tin-tuc/${hotNews.CategorySlug}/${
												hotNews.SEO.Slug || BASE_CONFIG.DEFAULT_SEO_SLUG
											}/${hotNews.Id}`}
										>
											<h2 className="info-title">{hotNews.Name}</h2>
										</Link>
										<p className="info-description">{hotNews.Summary}</p>
									</div>
								</div>
							</div>
						</div>
					</Col>
				)}
			</Row>
		</div>
	)
}

export default PostNewsList
